/**
 * Chat service — AI parser, confirm, and chat history.
 * @module services/chatService
 */
import { api } from "../lib/api";

export const chatService = {
  /**
   * @param {string} message
   * @returns {Promise<import("./types").ChatResponse>}
   */
  send: (message) =>
    api.post("/movements/chat", { message }).then((r) => r.data),

  /**
   * @param {import("./types").ChatItem[]} items
   * @param {string} [attachmentId] — Optional pending OCR attachment to link to the saved items.
   * @returns {Promise<{ok:true, saved:{movements:any[],receivables:any[],payments:any[],investments:any[],debts:any[],goals:any[]}, attachment:any}>}
   */
  confirm: (items, attachmentId = null) =>
    api.post("/movements/chat/confirm", {
      items,
      ...(attachmentId ? { attachment_id: attachmentId } : {}),
    }).then((r) => r.data),

  /**
   * @param {number} [limit]
   * @returns {Promise<import("./types").ChatMessage[]>}
   */
  history: (limit = 50) =>
    api.get("/movements/chat/history", { params: { limit } }).then((r) => r.data),

  /** @returns {Promise<{ok:true, deleted:number}>} */
  clearHistory: () =>
    api.delete("/movements/chat/history").then((r) => r.data),

  /**
   * iter-169s — Upload a receipt/voucher image and get back parsed items.
   * @param {File} file
   * @returns {Promise<{ok:true, items:any[], notes:string, model:string, credits_charged:number}>}
   */
  extractImage: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post("/movements/chat/extract-image", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data);
  },
};
